var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91 7.265a1 1 0 0 0-1.414.057l-3.23 3.5a1 1 0 0 0 0 1.356l3.23 3.5a1 1 0 0 0 1.47-1.356L8.284 12.5H18a1 1 0 1 0 0-2H8.284l1.682-1.822a1 1 0 0 0-.057-1.413Z",
    fill: "#777E91"
  })));
};
export default SvgLine;